var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.3686 16 16 12.3765 16 8C16 3.63137 12.3608 0 7.99216 0C3.61569 0 0 3.63137 0 8C0 12.3765 3.62353 16 8 16ZM7.99964 14.6667C4.29768 14.6667 1.34082 11.702 1.34082 8.00004C1.34082 4.30592 4.28984 1.33337 7.9918 1.33337C11.6859 1.33337 14.6585 4.30592 14.6663 8.00004C14.6742 11.702 11.6938 14.6667 7.99964 14.6667ZM5.85081 10.9725H6.59591C6.96453 10.9725 7.13708 10.7686 7.13708 10.4706V5.53724C7.13708 5.2392 6.96453 5.03528 6.59591 5.03528H5.85081C5.46649 5.03528 5.29395 5.2392 5.29395 5.53724V10.4706C5.29395 10.7686 5.46649 10.9725 5.85081 10.9725ZM9.3957 10.9725C9.02707 10.9725 8.84668 10.7686 8.84668 10.4706V5.53724C8.84668 5.2392 9.02707 5.03528 9.3957 5.03528H10.1408C10.5173 5.03528 10.6898 5.2392 10.6898 5.53724V10.4706C10.6898 10.7686 10.5173 10.9725 10.1408 10.9725H9.3957Z",
    fill: "#EC691A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.84bff55c7a6207a83bb467f7781a6b28.svg";
export { ForwardRef as ReactComponent };